import {
  Box,
  Button,
  Grid,
  GridItem,
  Heading,
  HStack,
  Spinner,
  Text,
  useDisclosure,
  useToast,
  VStack
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { useNavigate, useParams } from 'react-router-dom';

import { AcidentesPessoaisIcon } from '../../../../assets/icons/AcidentesPessoaisIcon';
import { PencilIcon } from '../../../../assets/icons/PencilIcon';
import { SadFaceIcon } from '../../../../assets/icons/SadFaceIcon';
import { TrashIcon } from '../../../../assets/icons/TrashIcon';
import { VidaIndividualIcon } from '../../../../assets/icons/VidaIndividualIcon';
import { VidaMulherIcon } from '../../../../assets/icons/VidaMulherIcon';
import { VidaSimplesIcon } from '../../../../assets/icons/VidaSimplesIcon';
import { WhiteLabelWrapper } from '../../../../components/layouts/WhiteLabelWrapper';
import { WhiteLabelNavigator } from '../../../../components/navigation/WhiteLabelNavigator';
import { BoxCritical } from '../../../../components/white-label/BoxCritical';
import { ModalConfirm } from '../../../../components/white-label/modals/ModalConfirm';
import { ModalSelectProducts } from '../../../../components/white-label/modals/ModalSelectProducts';
import { WhiteLabelSteps } from '../../../../components/white-label/WhiteLabelSteps';
import { StepsFormActions } from '../../../../contexts/StepsContext';
import { useStepsForm } from '../../../../hooks/useStepsForm';
import { apiSensedia } from '../../../../services/api-sensedia';
import { getDGCoverIdByProductIdAndCoverType } from '../../../../utils/covers.util';
import { formatDate } from '../../../../utils/date.util';
import { compare } from '../../../../utils/sorting.util';
import { WarningTextBox } from '../../previdencia-individual/movimentacao-fundos/components/WarningTextBox';

let apiWl = apiSensedia;

if (process.env.NODE_ENV != 'development') {
  apiWl = apiSensedia;
}

const IDS_PRODUTOS = [
  process.env.REACT_APP_PRODUTO_BASE,
  process.env.REACT_APP_PRODUTO_BASE_VF
];

export const StepTwo = (): JSX.Element => {
  const { idWebsite } = useParams();

  const [produtosBase, setProdutosBase] = useState<Array<any>>([]);

  const [produtoBaseEscolhido, setProdutoBaseEscolhido] = useState<any>({});

  const [criticasProdutos, setCriticasProdutos] = useState([
    { id_produto: '', CRITICA_NOME_PRODUTO: '', CRITICA_DESC_PRODUTO: '' }
  ]);

  const [criticaSelecionada, setCriticaSelecionada] = useState({
    CRITICA_NOME_PRODUTO: '',
    CRITICA_DESC_PRODUTO: ''
  });

  const [productsArrived, setProductsArrived] = useState(true);

  const [idProdutoBase, setIdProdutoBase] = useState(0);

  const [codigoCorretor, setCodigoCorretor] = useState(0);

  const [produtosCustomizados, setProdutosCustomizados] = useState([
    {
      sub_titulo: '',
      product_id: '',
      updatedAt: '',
      order_index: 0,
      id_produto: 0
    }
  ]);

  const [selectedProduct, setSelectedProduct] = useState('');
  const [selectedProducts, setSelectedProducts] = useState<Array<string>>([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { state, setState } = useStepsForm();

  const [typeAction, setTypeAction] = useState({
    type: '',
    id: ''
  });

  const [modalSelectProductsOpen, setModalSelectProductsOpen] = useState(false);

  const handleSelectedProducts = (productTitle: string) => {
    selectedProducts.push(productTitle);
    setSelectedProducts([...selectedProducts]);
  };

  const toast = useToast();
  const navigate = useNavigate();

  const getProdutos = async () => {
    try {
      IDS_PRODUTOS.forEach(async (idProduto) => {
        if (produtosBase.length != IDS_PRODUTOS.length) {
          const res = await apiWl.get(`/produtos/${idProduto}`);
          console.log('produto base buscado', res.data);
          produtosBase.push(res.data);
          const produtosBaseNew = [...produtosBase];
          setProdutosBase(produtosBaseNew);
        }
      });
    } catch (erro) {
      console.log(erro);
    }
  };

  const compareProducts = (a: any, b: any) => {
    return compare(a, b, 'order_index');
  };

  const getProdutosCustomizados = async () => {
    setProductsArrived(false);

    try {
      const res = await apiWl.get(
        `/websites/${idWebsite}/produtos-customizados`
      );

      const produtosCustomizados = res.data as any[];

      console.log('produtos customizados', produtosCustomizados);

      produtosCustomizados.sort(compareProducts);

      setProdutosCustomizados(produtosCustomizados);

      setProductsArrived(true);

      const resWebsite = await apiWl.get(`/websites/${idWebsite}`);

      console.log('última crítica', resWebsite.data.ultimaCritica);

      setCodigoCorretor(resWebsite.data?.codigo_corretor);

      if (resWebsite.data.ultimaCritica) {
        const arrayCriticasProdutos =
          resWebsite.data.ultimaCritica.parametros_website.produtos.map(
            (criticaProduto: any) => {
              return {
                id_produto: criticaProduto.id_produto,
                CRITICA_NOME_PRODUTO: criticaProduto.param_nome_produto,
                CRITICA_DESC_PRODUTO: criticaProduto.param_descricao_produto
              };
            }
          );

        setCriticasProdutos(arrayCriticasProdutos);
      }
    } catch (erro) {
      console.log(erro);
    }
  };

  const updateProducts = async (produtos: any[]) => {
    try {
      console.log('enviando update', produtos);
      await apiWl.post(`/produtos-customizados`, {
        website: produtos[0].website,
        massUpdateContent: produtos
      });
    } catch (error) {
      console.log(error);
    }
  };

  const isProductCriticized = (id_produto: string) => {
    const criticaProdSelecionada = criticasProdutos.filter((critica) => {
      if (critica.id_produto == id_produto) {
        return {
          CRITICA_NOME_PRODUTO: critica.CRITICA_NOME_PRODUTO,
          CRITICA_DESC_PRODUTO: critica.CRITICA_DESC_PRODUTO
        };
      }
    })[0];

    return !!criticaProdSelecionada;
  };

  const deleteProdutosCustomizados = async (id: string) => {
    try {
      await apiWl.delete(`/websites/${idWebsite}/produtos-customizados/${id}`);
      setModalSelectProductsOpen(false);
      getProdutosCustomizados();
      onClose();
    } catch (erro) {
      console.log(erro);
    }
  };

  const getProductById = (prodId: string) => {
    for (let i = 0; i < produtosCustomizados.length; i++) {
      if (produtosCustomizados[i].product_id === prodId) {
        return produtosCustomizados[i];
      }
    }
    return {} as any;
  };

  const getBaseProductById = (prodId: number) => {
    for (let i = 0; i < produtosBase.length; i++) {
      if (produtosBase[i].id_produto == prodId) {
        return produtosBase[i];
      }
    }
    return {} as any;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getProdutos();
    getProdutosCustomizados();
  }, []);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    e.stopPropagation();

    if (!produtosCustomizados.length) {
      toast({
        position: 'top',
        description: `É necessário adicionar um produto`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else if (
      produtosCustomizados.some(
        (produtoCustomizado) =>
          !IDS_PRODUTOS.includes(produtoCustomizado.id_produto.toString())
      )
    ) {
      toast({
        position: 'top',
        description:
          'Você possui um ou mais produtos que não estão mais em comercialização. Remova-os e tente novamente.',
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else {
      navigate(`/corretor/white-label/step-four/${idWebsite}/`);
    }
  };

  const getCoberturaMorte = () => {
    const coberturas = produtoBaseEscolhido.cobertura;
    if (coberturas) {
      for (let i = 0; i < coberturas.length; i++) {
        if (coberturas[i].is_cobertura_morte) {
          return coberturas[i].capitais_disponiveis;
        }
      }
    }
    return [];
  };

  const handleOpenModalForCreate = async (produto: any) => {
    setIdProdutoBase(0);
    try {
      setState({
        type: StepsFormActions.setCapital,
        payload: ''
      });
      setState({
        type: StepsFormActions.setCapitalMin,
        payload: ''
      });
      setState({
        type: StepsFormActions.setCapitalMax,
        payload: ''
      });
      setState({
        type: StepsFormActions.setAssist,
        payload: [{}]
      });
      setState({
        type: StepsFormActions.setCover,
        payload: [{}]
      });
      setState({
        type: StepsFormActions.setNameProduct,
        payload: ''
      });
      setState({
        type: StepsFormActions.setDescriptionProduct,
        payload: ''
      });
      setState({
        type: StepsFormActions.setHasVariableCapital,
        payload: false
      });
      setState({
        type: StepsFormActions.setBrokerage,
        payload: ''
      });
      setState({
        type: StepsFormActions.setAgency,
        payload: ''
      });
      // setState({
      //   type: StepsFormActions.setFrequency,
      //   payload:  ''    // });
      setState({
        type: StepsFormActions.setRegisteredPartner,
        payload: ''
      });
      setState({
        type: StepsFormActions.setPercentage,
        payload: ''
      });
      setState({
        type: StepsFormActions.setPartner,
        payload: ''
      });
    } catch (erro) {
      console.log(erro);
    }
    produto.cobertura = (produto.cobertura as []).sort((a: any, b: any) => {
      if (a.is_cobertura_morte !== b.is_cobertura_morte) {
        return a.is_cobertura_morte ? -1 : 1;
      }
      if (a.binded_to_death_cob !== b.binded_to_death_cob) {
        return a.is_cobertura_morte ? -1 : 1;
      }
      return a.descricao.localeCompare(b.descricao);
    });
    setProdutoBaseEscolhido(produto);
    setModalSelectProductsOpen(true);
    onClose();
  };

  const handleOpenModalForUpdate = async (id: string) => {
    try {
      const res = await apiWl.get(
        `/websites/${idWebsite}/produtos-customizados/${id}`
      );

      const produtoCustomizado = res.data;

      const coberturas = produtoCustomizado.coberturas;

      for (let j = 0; j < coberturas.length; j++) {
        const cobertura = coberturas[j];

        if (coberturas[j].doencas?.length) {
          coberturas[j].id_cobertura = getDGCoverIdByProductIdAndCoverType(
            produtoCustomizado.id_produto,
            cobertura.dg_pack_type
          );
        }
      }

      setIdProdutoBase(res.data.id_produto);
      const produtoBase = getBaseProductById(res.data.id_produto);
      produtoBase.cobertura = (produtoBase.cobertura as []).sort(
        (a: any, b: any) => {
          if (a.is_cobertura_morte !== b.is_cobertura_morte) {
            return a.is_cobertura_morte ? -1 : 1;
          }
          if (a.binded_to_death_cob !== b.binded_to_death_cob) {
            return a.is_cobertura_morte ? -1 : 1;
          }
          return a.descricao.localeCompare(b.descricao);
        }
      );

      setProdutoBaseEscolhido(produtoBase);

      setState({
        type: StepsFormActions.setCapital,
        payload: res.data.valor_renda?.toString()
      });
      setState({
        type: StepsFormActions.setCapitalMin,
        payload: res.data.valor_minimo_contrata?.toString()
      });
      setState({
        type: StepsFormActions.setCapitalMax,
        payload: res.data.valor_maximo_contrata?.toString()
      });

      setState({
        type: StepsFormActions.setAssist,
        payload: res.data.servicos
      });
      setState({
        type: StepsFormActions.setCover,
        payload: res.data.coberturas
      });
      setState({
        type: StepsFormActions.setNameProduct,
        payload: res.data.sub_titulo
      });
      setState({
        type: StepsFormActions.setDescriptionProduct,
        payload: res.data.descricao_produto
      });
      setState({
        type: StepsFormActions.setHasVariableCapital,
        payload: res.data.possui_capital_variavel
      });
      setState({
        type: StepsFormActions.setBrokerage,
        payload: res.data.corretagem
      });
      setState({
        type: StepsFormActions.setAgency,
        payload: res.data.agenciamento
      });
      // setState({
      //   type: StepsFormActions.setFrequency,
      //   payload: res.data.periodicidade
      // });
      setState({
        type: StepsFormActions.setRegisteredPartner,
        payload: res.data.ev_parceria
      });
      setState({
        type: StepsFormActions.setPercentage,
        payload: res.data.intermediacao
      });
      setState({
        type: StepsFormActions.setPartner,
        payload: res.data.ev_parceria && res.data.intermediacao
      });
    } catch (erro) {
      console.log(erro);
    }

    setModalSelectProductsOpen(true);
    onClose();
  };

  useEffect(() => {
    console.log('produtosBase', produtosBase);
  }, [produtosBase]);

  return (
    <>
      <WhiteLabelWrapper>
        <Box p="40px 56px">
          <VStack gap="30px">
            <HStack w="100%" justifyContent="space-between">
              <Box id="top">
                <Heading>Configuração do site</Heading>
                <Text>Escolha qual produto quer personalizar.</Text>
              </Box>
              <WhiteLabelSteps currentStep={2} />
            </HStack>
            <WarningTextBox
              content="Atenção: O Produto Vida Individual será substituido pelo novo produto Vida Flex! A partir de 02/04, você terá 30 dias para atualizar seus links criados. Não deixe para última hora, atualize agora mesmo!"
              full={true}
            />
            <Box
              background="#FFFFFF"
              width="100%"
              boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
              borderRadius="24px"
              padding="30px"
            >
              <Heading
                id="productsStepTwo"
                fontSize="1.5rem"
                fontStyle="normal"
                fontWeight="700"
                lineHeight="2rem"
                color="#001E64"
              >
                Produtos
              </Heading>
              <HStack mt="40px" flexWrap="wrap" columnGap="39px" rowGap="30px">
                {produtosBase
                  .filter((prod) => !prod.hidden)
                  .map((prod, index) => {
                    return (
                      <Box
                        key={index}
                        w="321px"
                        borderRadius="24px"
                        overflow="hidden"
                        boxShadow="0px 0px 5px rgba(50, 50, 50, 0.25)"
                        m="0 !important"
                      >
                        <Box p="30px">
                          <HStack gap="20px">
                            {(() => {
                              if (prod.identifier === 'acidentes_pessoais') {
                                return (
                                  <AcidentesPessoaisIcon
                                    w="4.313rem"
                                    h="5.938rem"
                                  />
                                );
                              } else if (
                                prod.identifier === 'vida_individual'
                              ) {
                                return (
                                  <VidaIndividualIcon
                                    w="4.313rem"
                                    h="5.938rem"
                                  />
                                );
                              } else if (prod.identifier === 'vida_flex') {
                                return (
                                  <VidaIndividualIcon
                                    w="4.313rem"
                                    h="5.938rem"
                                  />
                                );
                              } else if (prod.identifier === 'vida_mulher') {
                                return (
                                  <VidaMulherIcon w="4.313rem" h="5.938rem" />
                                );
                              } else if (prod.identifier === 'vida_simples') {
                                return (
                                  <VidaSimplesIcon w="4.313rem" h="5.938rem" />
                                );
                              }
                            })()}

                            <Text
                              color="#146CFA"
                              fontSize="1.5rem"
                              fontWeight="bold"
                              m="0 !important"
                            >
                              {prod.descricao}
                            </Text>
                          </HStack>
                        </Box>
                        <Box
                          width="100%"
                          padding="30px 0"
                          bg="#F6F6F6"
                          display="flex"
                          justifyContent="center"
                        >
                          <Button
                            w="262px"
                            h="48px"
                            bg="#FF5000"
                            color="white"
                            borderRadius="133.5px"
                            _hover={{}}
                            sx={{
                              '&:focus': {
                                boxShadow: 'none !important'
                              }
                            }}
                            onClick={() => {
                              handleOpenModalForCreate(prod);
                            }}
                          >
                            Adicionar produto
                          </Button>
                        </Box>
                      </Box>
                    );
                  })}
              </HStack>
            </Box>
            <Box
              background="#FFFFFF"
              width="100%"
              boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
              borderRadius="24px"
              padding="30px"
            >
              <Heading
                fontSize="1.5rem"
                fontStyle="normal"
                fontWeight="700"
                lineHeight="2rem"
                color="#001E64"
              >
                Lista de produtos adicionados
              </Heading>
              {!productsArrived ? (
                <Box
                  w="100%"
                  h="55vh"
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  gridGap="15px"
                >
                  <Spinner
                    thickness="6px"
                    speed="0.65s"
                    emptyColor="#FF5000"
                    color="#FFFFFF"
                    size="xl"
                  />
                  <Text>Carregando Produtos...</Text>
                </Box>
              ) : (
                <Box width="100%" minH="400px">
                  <DragDropContext
                    onDragEnd={(params) => {
                      const sourceIndex = params.source.index;
                      const destIndex = params.destination?.index || 0;

                      const nothingHappened = sourceIndex === destIndex;
                      const isDraggingDown = sourceIndex < destIndex;

                      const prodsArray = [];

                      if (!nothingHappened) {
                        const product = getProductById(params.draggableId);
                        product.order_index = destIndex;
                        prodsArray.push(product);
                        console.log('produto modificado', product);
                        if (isDraggingDown) {
                          const arr = produtosCustomizados.filter((prod) => {
                            if (
                              prod.order_index <= destIndex &&
                              prod.order_index >= sourceIndex &&
                              prod.product_id != product.product_id
                            ) {
                              prod.order_index = prod.order_index - 1;
                            }

                            if (prod.product_id != product.product_id) {
                              return prod;
                            }
                          });

                          prodsArray.push(...arr);
                        } else {
                          const arr = produtosCustomizados.filter((prod) => {
                            if (
                              prod.order_index >= destIndex &&
                              prod.order_index <= sourceIndex &&
                              prod.product_id != product.product_id
                            ) {
                              prod.order_index = prod.order_index + 1;
                            }

                            if (prod.product_id != product.product_id) {
                              return prod;
                            }
                          });

                          prodsArray.push(...arr);
                        }
                      }

                      prodsArray.sort(compareProducts);

                      if (prodsArray.length === produtosCustomizados.length) {
                        setProdutosCustomizados(prodsArray);
                        updateProducts(prodsArray);
                      }

                      console.log('arrastou', params, prodsArray);
                    }}
                  >
                    {produtosCustomizados.length ? (
                      <VStack>
                        <Grid
                          templateColumns="repeat(3, 1fr)"
                          p="15px 30px"
                          width="100%"
                        >
                          <GridItem>
                            <Box>
                              <Text
                                fontSize="0.875rem"
                                fontWeight="bold"
                                color="#001E64"
                              >
                                Produto
                              </Text>
                            </Box>
                          </GridItem>
                          <GridItem>
                            <Box display="flex" justifyContent="center">
                              <Box>
                                <Text
                                  fontSize="0.875rem"
                                  fontWeight="bold"
                                  color="#001E64"
                                >
                                  Data da modificação
                                </Text>
                              </Box>
                            </Box>
                          </GridItem>
                          <GridItem>
                            <Box display="flex" justifyContent="end">
                              <Box mr="20px">
                                <Text
                                  fontSize="0.875rem"
                                  fontWeight="bold"
                                  color="#001E64"
                                >
                                  Ação
                                </Text>
                              </Box>
                            </Box>
                          </GridItem>
                        </Grid>
                        <Droppable droppableId="droppable-products">
                          {(provided, _) => (
                            <Box
                              as={'div'}
                              width="100%"
                              ref={provided.innerRef}
                              {...provided.droppableProps}
                            >
                              {produtosCustomizados.map((item, index) => {
                                return (
                                  <Draggable
                                    key={item.product_id}
                                    draggableId={item.product_id}
                                    index={index}
                                  >
                                    {(provided, _) => (
                                      <Box
                                        as={'div'}
                                        width="100%"
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                      >
                                        <Grid
                                          templateColumns="repeat(3, 1fr)"
                                          p="10px 30px"
                                          width="100%"
                                          borderLeft="5px solid #FF5000"
                                          borderRadius="6px"
                                          bg={
                                            index % 2 === 0
                                              ? '#F4F4F4'
                                              : 'rgba(211, 222, 237, 0.5)'
                                          }
                                        >
                                          <GridItem>
                                            <Box
                                              display="flex"
                                              alignItems="center"
                                              gridGap="10px"
                                            >
                                              <Text
                                                color="#001E64"
                                                fontSize="0.875rem"
                                              >
                                                {item.sub_titulo}
                                              </Text>
                                            </Box>
                                          </GridItem>
                                          <GridItem>
                                            <Box
                                              width="100%"
                                              display="flex"
                                              justifyContent="center"
                                            >
                                              <Box>
                                                <Text
                                                  color="#146CFA"
                                                  fontSize="0.875rem"
                                                  fontWeight="bold"
                                                >
                                                  {formatDate(
                                                    new Date(item.updatedAt)
                                                  )}
                                                </Text>
                                              </Box>
                                            </Box>
                                          </GridItem>
                                          <GridItem>
                                            <Box
                                              width="100%"
                                              display="flex"
                                              justifyContent="end"
                                            >
                                              <Box
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="center"
                                                gap="13px"
                                              >
                                                <TrashIcon
                                                  w="1.5rem"
                                                  h="1.5rem"
                                                  cursor="pointer"
                                                  onClick={() => {
                                                    // setCriticaSelecionada({
                                                    //   CRITICA_PRODUTO: ''
                                                    // });
                                                    setTypeAction({
                                                      type: 'delete',
                                                      id: item.product_id
                                                    });
                                                    onOpen();

                                                    // deleteProdutosCustomizados(
                                                    //   item.product_id
                                                    // );
                                                  }}
                                                />
                                                <PencilIcon
                                                  w="1.25rem"
                                                  h="1.25rem"
                                                  cursor="pointer"
                                                  onClick={() => {
                                                    setTypeAction({
                                                      type: 'update',
                                                      id: item.product_id
                                                    });
                                                    onOpen();
                                                    // handleOpenModalForUpdate(item.product_id);
                                                    if (
                                                      criticasProdutos[0]
                                                        .id_produto
                                                    ) {
                                                      const criticaProdSelecionada =
                                                        criticasProdutos.filter(
                                                          (critica) => {
                                                            console.log(
                                                              'product_id',
                                                              item.product_id
                                                            );
                                                            if (
                                                              critica.id_produto ==
                                                              item.product_id
                                                            ) {
                                                              return {
                                                                CRITICA_NOME_PRODUTO:
                                                                  critica.CRITICA_NOME_PRODUTO,
                                                                RITICA_DESC_PRODUTO:
                                                                  critica.CRITICA_DESC_PRODUTO
                                                              };
                                                            }
                                                          }
                                                        )[0];

                                                      setCriticaSelecionada(
                                                        criticaProdSelecionada
                                                      );

                                                      console.log(
                                                        'criticaProdSelecionada',
                                                        criticaProdSelecionada
                                                      );
                                                    }

                                                    setState({
                                                      type: StepsFormActions.setIdProduct,
                                                      payload: item.product_id
                                                    });
                                                  }}
                                                />
                                              </Box>
                                            </Box>
                                          </GridItem>
                                        </Grid>
                                        <Box
                                          w="100%"
                                          m="0px 0 20px 0 !important"
                                        >
                                          {isProductCriticized(
                                            item.product_id
                                          ) ? (
                                            <BoxCritical
                                              textContent={
                                                'produto com críticas'
                                              }
                                            />
                                          ) : undefined}
                                        </Box>
                                      </Box>
                                    )}
                                  </Draggable>
                                );
                              })}
                              {provided.placeholder}
                            </Box>
                          )}
                        </Droppable>
                      </VStack>
                    ) : (
                      <Box
                        width="100%"
                        minH="400px"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        flexDirection="column"
                      >
                        <SadFaceIcon h="5.8rem" w="4.688rem" />
                        <Text mt="30px" color="#AAAAAA" fontSize="1rem">
                          Parece que você não tem nenhum produto registrado
                        </Text>
                      </Box>
                    )}
                  </DragDropContext>
                </Box>
              )}
            </Box>

            <WhiteLabelNavigator
              isDisabled={false}
              hrefPrev={`/corretor/white-label/step-one/${idWebsite}`}
              nextAction={(e: any) => handleSubmit(e)}
              btnNextText={'Salvar e Continuar'}
            />
          </VStack>
        </Box>
      </WhiteLabelWrapper>
      {modalSelectProductsOpen && (
        <ModalSelectProducts
          idProduto={idProdutoBase}
          title={selectedProduct}
          isOpen={true}
          onClose={() => {
            setModalSelectProductsOpen(false);
          }}
          handleSelectedProducts={handleSelectedProducts}
          product={produtoBaseEscolhido}
          getProdutosCustomizados={getProdutosCustomizados}
          critica={criticaSelecionada}
          allowedValues={getCoberturaMorte()}
          codigoCorretor={codigoCorretor}
        />
      )}
      <ModalConfirm
        content={
          typeAction.type === 'update'
            ? 'Tem certeza que deseja alterar esse Produto?'
            : 'Tem certeza que deseja excluir esse Produto?'
        }
        submit={
          typeAction.type === 'update'
            ? () => {
                handleOpenModalForUpdate(typeAction.id);
              }
            : () => {
                deleteProdutosCustomizados(typeAction.id);
              }
        }
        isOpen={isOpen}
        onClose={onClose}
      />
    </>
  );
};
